import { render, staticRenderFns } from "./ZRadio.vue?vue&type=template&id=5122452a&"
import script from "./ZRadio.vue?vue&type=script&lang=js&"
export * from "./ZRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports